import { KEYCLOAK_CONFIG } from '../config/env';

/**
 * Build a Keycloak Admin Console URL for a realm-relative path.
 * Admin Console v2+ uses hash routing: /admin/master/console/#/{realm}/{path}
 */
export function getKeycloakAdminUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;

  const normalizedPath = path.replace(/^\/+/, '');
  const keycloakBase = KEYCLOAK_CONFIG.url.replace(/\/$/, '');
  const realm = KEYCLOAK_CONFIG.realm;

  return `${keycloakBase}/admin/master/console/#/${realm}/${normalizedPath}`;
}
